"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var css = require("@material/typography/mdc-typography.scss");
exports.default = css;
